module.exports = __webpack_public_path__ + "static/media/justin.6a8fb1b5.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/Pictures/pics/justin.jpeg
// module id = 136
// module chunks = 0